/* eslint-disable react/no-danger */
import {useEffect, useState} from 'react';
import DOMPurify from 'dompurify';
import usePrivacy from './usePrivacy';
import {PageTitle} from '../../../providers/PageDataProvider';
import {useI18n} from '../../../providers/I18nProvider';

const Privacy = () => {
	const [htmlContent, setHtmlContent] = useState({html: ''});

	const {data} = usePrivacy();

	const {i18n} = useI18n();

	async function createMarkUp() {
		const backendHtml = data?.data.body;
		return {html: backendHtml || ''};
	}
	createMarkUp().then((result) => setHtmlContent(result));

	useEffect(() => {
		const splashScreen = document.getElementById('splash-screen');
		splashScreen?.classList.add('hidden');
	}, []);

	return (
		<div className='px-12 py-6'>
			<PageTitle>{i18n('PRIVACYPOLICY')}</PageTitle>
			<div dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(htmlContent.html)}} className='text-justify' />
		</div>
	);
};

export default Privacy;
